import * as mutations from './mutations'
import * as actions from './actions'
import * as getters from './getters'
import address from '@/store/shared/address'
import dir3 from '@/store/shared/dir3'
import contactMedium from '@/store/shared/contactMedium'
import dire from '@/store/shared/dire'

export default {
  namespaced: true,
  state () {
    return {
      id: undefined,
      type: 'NP',
      residence: 'R',
      tradeName: undefined,
      name: undefined,
      lastName: undefined,
      document: undefined,
      contractReference: undefined,
      mercantileRegistry: undefined,
      source: undefined,
      additionalInfo: [],
      rawadditionalInfo: {},
      loaded: false,
      hasContactMedium: false,
      hasContractReference: false,
      hasCustomInvoice: false,
      dirType: undefined,
      isContractReferenceMandatory: false
    }
  },
  mutations,
  actions,
  getters,
  modules: {
    address,
    contactMedium,
    FACeB2B: dire,
    accountingOffice: dir3,
    managerBody: dir3,
    processingUnit: dir3,
    proponentBody: dir3
  }
}
